import React from 'react';
import Styles from './Car.module.css';
import { Icon } from '@iconify/react';
import { GiDiscGolfBag } from "react-icons/gi";
import { NavLink } from 'react-router-dom';


const Card = ({ image, model, group, People, fuel, litre, bag, transmission, price, link }) => {
  return (

    <li>

      <div className={Styles.featured_car_card}>

        <figure className={Styles.card_banner}>
          <img src={image} alt='/' className={Styles.w_100} />
        </figure>

        <div className={Styles.card_content}>

          <div className={Styles.card_title_wrapper}>
            <h3 className={`${Styles.h3} ${Styles.card_title} `}>
              <a href="#">{model}</a>
            </h3>

            <span className={Styles.group} >{group}</span>
          </div>

          <ul className={Styles.card_list}>

            <li className={Styles.card_list_item}>
              <ion-icon name="people-outline"></ion-icon>

              <span className={Styles.card_item_text}>{People}</span>
            </li>

            <li className={Styles.card_list_item}>
              <GiDiscGolfBag color="#d4002a" />

              <span className={Styles.card_item_text}>{bag}</span>
            </li>



            <li className={Styles.card_list_item}>
              <ion-icon name="flash-outline"></ion-icon>

              <span className={Styles.card_item_text}>{fuel}</span>
            </li>


            {/* <li className={Styles.card_list_item}>
              <ion-icon name="speedometer-outline"></ion-icon>

              <span className={Styles.card_item_text}>{litre}</span>
            </li> */}

            <li className={Styles.card_list_item}>
              <Icon icon="material-symbols:auto-transmission" color="#d4002a" />

              <span className={Styles.card_item_text}>{transmission}</span>
            </li>

          </ul>

          <div className={Styles.card_price_wrapper}>

            <p className={Styles.card_price}>
              <strong>€{price}</strong> / day
            </p>

            {/* <button className={`${Styles.btn} ${Styles.fav_btn}`} aria-label="Add to favourite list">
                      <ion-icon name="heart-outline"></ion-icon>
                    </button> */}



            <NavLink to={link}><a href='/#'><button className={Styles.btn}>Rent now</button></a></NavLink>
          </div>

        </div>

      </div>
    </li>

  );
}

export default Card;